<template>
	<el-card class="box-card" shadow="hover">
		<el-row>
			<el-col :span="18">
				<el-input placeholder="请输入产品名称关键字(模糊检索)" v-model="searchName" class="input-with-select">
					<!-- 请选择分类： -->
					<el-select placeholder="请选择" v-model="ProCategoryID"  slot="prepend">
						<el-option label="全部分类" value="">
						</el-option>
						<el-option v-for="item in proCategoryList" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-input>
			</el-col>
		</el-row>
	</el-card>
</template>

<script>
	export default{
		data(){
			return {
				searchName:'',
				ProCategoryID:''
			}
		},
		props:{
			proCategoryList:{
				type:Array
			}
		},
		watch:{
			searchName(val)
			{
				this.$emit('searchName',val)
			},
			ProCategoryID(val)
			{
				this.$emit('ProCategoryID',val)
			}
		}
	}
</script>

<style lang="scss">
	.el-select .el-input {
		width: 150px;
	}

	.input-with-select .el-input-group__prepend {
		background-color: #fff;
	}
</style>
